<div class="container-fluid">
    <div class="row justify-content-center py-2">
        <div class="col-11 col-md-5 col-xl-4">
            <div class="d-flex flex-column">
                <span class="section-title mt-2">Find your midwife</span>
                <div class="row mt-2">
                    <div class="col-6">
                        <div class="d-flex flex-column">
                            <span class="section-sub-title my-2 my-sm-1">Select Area</span>
                            <select id="area" [(ngModel)]="selectedArea" name="area" class="dropdown"
                                (change)="getSubAreas()">
                                <option value="All">All</option>
                                <option *ngFor="let area of areas" [value]="area.id">{{area.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="d-flex flex-column">
                            <span class="section-sub-title my-2 my-sm-1">Select Suburb</span>
                            <select id="subarea" [(ngModel)]="searchParam.serviceArea" (change)="searchMidwife()"
                                name="subarea" class="dropdown">
                                <option value="All">All</option>
                                <option *ngFor="let subArea of subAreas" [value]="subArea.name">
                                    {{subArea.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-lg-10">
                        <div class="d-flex flex-row">
                            <div class="input-icons">
                                <i class="fas fa-search navbar-icon"></i>
                                <input class="form-control form-control-sm header-search" placeholder="Search a Midwife"
                                    [(ngModel)]="searchParam.midwifeName" name="searchMidwife" required
                                    (keyup.enter)="searchMidwife()">
                            </div>
                            <button (click)="searchMidwife()" class="btn btn-lg btn-theme ml-3">Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-11 col-md-6">
            <div class="row filter-group">
                <div class="col-sm-6 col-md-7 col-lg-5 col-xl-4">
                    <div class="d-flex flex-column">
                        <span class="show-filter pl-2"><span (click)="toggleFilter()">{{filterMessage}}</span>
                            <button class="clear-btn" *ngIf="clearBtn" (click)="reset()">Clear all<i
                                    class="fas fa-times-circle ml-1"></i></button>
                        </span>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-3">
                    <div class="d-flex flex-column mt-1 mt-sm-0">
                        <span class="section-sub-title my-2 my-sm-1">Sort by</span>
                        <select [(ngModel)]="searchParam.sortingCriteria" (change)="searchMidwife()" name="sortby"
                            id="sortby" class="dropdown">
                            <option value="A_Z_ASC">Name A-Z</option>
                            <option value="A_Z_DESC">Name Z-A</option>
                            <option value="RATING_ASC">Rating ASC</option>
                            <option value="RATING_DESC">Rating DESC</option>
                            <option value="EXPERIENCE_ASC">Experience ASC</option>
                            <option value="EXPERIENCE_DESC">Experience DESC</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr class="m-0" *ngIf="displayFilter">
    <div class="row my-2 justify-content-center" *ngIf="displayFilter">
        <div class="col-11 col-xl-10">
            <div class="row">
                <div class="col-6 col-sm-4 col-md-3">
                    <div class="d-flex flex-column">
                        <span class="section-sub-title my-2 my-sm-1">Experience</span>
                        <select [(ngModel)]="searchParam.minimumExperience" (change)="searchMidwife()" name="experience"
                            id="experience" class="dropdown">
                            <option value="0">All</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select>
                    </div>
                </div>
                <div class="col-6 col-sm-4 col-md-3">
                    <div class="d-flex flex-column">
                        <span class="section-sub-title my-2 my-sm-1">Ethnicity</span>
                        <select [(ngModel)]="searchParam.ethnicity" (change)="searchMidwife()" name="ethnicity"
                            id="ethnicity" class="dropdown">
                            <option value="All">All</option>
                            <option [value]="ethnicity" *ngFor="let ethnicity of ethnicities">{{ethnicity}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-6 col-sm-4 col-md-3">
                    <div class="d-flex flex-column">
                        <span class="section-sub-title my-2 my-sm-1">Specialized in</span>
                        <select [(ngModel)]="searchParam.speciality" (change)="searchMidwife()" name="specialized"
                            id="specialized" class="dropdown">
                            <option value="All">All</option>
                            <option [value]="speciality" *ngFor="let speciality of specialities">{{speciality}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>